import React from 'react';

import './PostExplanation.scss';
import { PostResponse } from '../../../../../types/models/posts';

import { TextShowcaseGroup } from '../../shared/TextShowcaseGroup/TextShowcaseGroup';
import { PostCard } from '../../../../../components/cards/PostCard/PostCard';

interface IPostExplanation {
  demoPost: PostResponse;
};

export function PostExplanation({ demoPost }: IPostExplanation) {
  return (
    <div className='PostExplanation'>
      <TextShowcaseGroup areSizesReverse={ false } isReverse={ true }  areItemsCentered={ true }>
        <div className='PostExplanation__text'>
          <p>Press "+" if you agree with the author's post.</p>
          <p>Press "-" if you disagree.</p>
          <p>Press "DETAILS" to see full post text and comments.</p>
          <p>You can't change or undo your reaction.</p>
        </div>
        
        <PostCard post={ demoPost } isDemo={ true } isShowcase={ true } />
      </TextShowcaseGroup>
    </div>
  );
}
